import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { Quote, Star } from "lucide-react";
import { fadeUp } from "./motion";
import { REVIEWS } from "../../data/site";

export const Reviews = () => {
  return (
    <section id="reviews" data-testid="reviews-section" className="relative bg-[#E6FBF3] overflow-hidden">
      <div className="py-20 sm:py-28">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 mb-12 text-center">
          <motion.span variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }}
            className="eyebrow text-[#F63C8B]">Loved Across California</motion.span>
          <motion.h2 variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }}
            className="font-display mt-3 text-[clamp(2rem,5vw,3.75rem)] leading-[1.02] text-[#2A1620] max-w-3xl mx-auto">
            Best rolled ice cream in <span className="font-script text-[#12B99B]">California</span>
          </motion.h2>
        </div>

        {/* editorial marquee */}
        <div className="py-3 mb-12">
          <Marquee speed={38} gradient={false} pauseOnHover>
            {["Freshly Rolled", "Premium Taste", "Made To Order", "Family First", "25 Flavors", "Unlimited Drizzles"].map((t, i) => (
              <span key={i} className="font-display text-4xl sm:text-6xl mx-8 text-stroke-pink">
                {t} <span className="text-[#FFC93C]">★</span>
              </span>
            ))}
          </Marquee>
        </div>

        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <motion.blockquote key={i} variants={fadeUp} custom={i % 3} initial="hidden" whileInView="show" viewport={{ once: true }}
              data-testid={`review-${i}`} className="card p-8 flex flex-col">
              <Quote className="text-[#F9A8CB]" size={30} />
              <div className="flex gap-0.5 mt-4">
                {Array.from({ length: 5 }).map((_, s) => <Star key={s} size={15} className="fill-[#FFC93C] text-[#FFC93C]" />)}
              </div>
              <p className="mt-4 text-[#3A2A32] leading-relaxed flex-1">"{r.text}"</p>
              <footer className="mt-6 pt-5 border-t border-[#F4C9DC]">
                <span className="font-display text-lg text-[#2A1620]">{r.name}</span>
                <span className="block text-xs font-bold uppercase tracking-[0.18em] text-[#12B99B] mt-1">{r.city}, CA</span>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
